var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.16 23.2H10.4582L7.11059 4.78827C7.07038 4.56708 6.9538 4.36701 6.7812 4.22296C6.60859 4.0789 6.3909 4 6.16608 4H4",
    stroke: "#054BC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6793 28.0001C13.0048 28.0001 14.0793 26.9256 14.0793 25.6001C14.0793 24.2746 13.0048 23.2001 11.6793 23.2001C10.3538 23.2001 9.2793 24.2746 9.2793 25.6001C9.2793 26.9256 10.3538 28.0001 11.6793 28.0001Z",
    stroke: "#054BC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1598 28.0001C25.4852 28.0001 26.5598 26.9256 26.5598 25.6001C26.5598 24.2746 25.4852 23.2001 24.1598 23.2001C22.8343 23.2001 21.7598 24.2746 21.7598 25.6001C21.7598 26.9256 22.8343 28.0001 24.1598 28.0001Z",
    stroke: "#054BC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5853 18.3999H24.652C25.1016 18.3999 25.537 18.2421 25.8822 17.954C26.2274 17.6659 26.4606 17.2658 26.541 16.8234L27.9998 8.79993H7.83984",
    stroke: "#054BC7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.3302d8a7bbfbed0c4d293bcb3293b93a.svg";
export { ForwardRef as ReactComponent };